import "../assets/index-ab715d82.css";
import o from "@nextcloud/axios";
import { generateOcsUrl as l } from "@nextcloud/router";
import a from "./NcButton.mjs";
import { t as s } from "../chunks/l10n-1b905a9a.mjs";
import { n } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const u = {
  name: "NcResource",
  components: {
    NcButton: a
  },
  props: {
    icon: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    url: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      labelTranslated: s('Open link to "{resourceName}"', { resourceName: this.name })
    };
  },
  methods: {
    t: s
  }
};
var c = function() {
  var e = this, t = e._self._c;
  return t("li", { staticClass: "resource" }, [t("NcButton", { staticClass: "resource__button", attrs: { "aria-label": e.labelTranslated, type: "tertiary", href: e.url }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t("div", { staticClass: "resource__icon" }, [t("img", { attrs: { src: e.icon } })])];
  }, proxy: !0 }]) }, [e._v(" " + e._s(e.name) + " ")])], 1);
}, d = [], p = /* @__PURE__ */ n(
  u,
  c,
  d,
  !1,
  null,
  "1a960bef",
  null,
  null
);
const f = p.exports;
const _ = {
  name: "NcRelatedResourcesPanel",
  components: {
    NcResource: f
  },
  props: {
    /**
     * The provider id implemented with `\OCA\RelatedResources\IRelatedResourceProvider::getProviderId()`
     */
    providerId: {
      type: String,
      default: null
    },
    /**
     * The item id which uniquely identities the e.g. Calendar event, Deck board, file, Talk room, etc.
     */
    itemId: {
      type: [String, Number],
      default: null
    },
    /**
     * Limits to specific resource type. i.e. any provider id implemented with `\OCA\RelatedResources\IRelatedResourceProvider::getProviderId()`
     */
    resourceType: {
      type: String,
      default: null
    },
    /**
     * Set the maximum number of resources to load
     */
    limit: {
      type: Number,
      default: null
    },
    /**
     * Only used by the files sidebar
     *
     * File info is passed when registered with `OCA.Sharing.ShareTabSections.registerSection()`
     */
    fileInfo: {
      type: Object,
      default: null
    },
    /**
     * Make the header name dynamic
     */
    header: {
      type: String,
      default: s("Related resources")
    },
    description: {
      type: String,
      default: s("Anything shared with the same group of people will show up here")
    },
    /**
     * If this element is used on a primary element set to true for primary styling.
     */
    primary: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "has-error",
    "has-resources"
  ],
  data() {
    var r;
    return {
      appEnabled: ((r = OC == null ? void 0 : OC.appswebroots) == null ? void 0 : r.related_resources) !== void 0,
      loading: !1,
      error: null,
      resources: []
    };
  },
  computed: {
    isVisible() {
      var r;
      return this.loading ? !1 : (r = this.error) != null ? r : this.resources.length > 0;
    },
    subline() {
      return this.error ? s("Error getting related resources. Please contact your system administrator if you have any questions.") : this.description;
    },
    hasResourceInfo() {
      return this.providerId !== null && this.itemId !== null || this.fileInfo !== null;
    },
    isFiles() {
      var r;
      return ((r = this.fileInfo) == null ? void 0 : r.id) !== void 0;
    },
    url() {
      let r = null, e = null;
      return this.isFiles ? (r = "files", e = this.fileInfo.id) : (r = this.providerId, e = this.itemId), l("/apps/related_resources/related/{providerId}?itemId={itemId}&resourceType={resourceType}&limit={limit}&format=json", {
        providerId: r,
        itemId: e,
        resourceType: this.resourceType,
        limit: this.limit
      });
    }
  },
  watch: {
    providerId() {
      this.fetchRelatedResources();
    },
    itemId() {
      this.fetchRelatedResources();
    },
    fileInfo() {
      this.fetchRelatedResources();
    },
    error(r) {
      this.$emit("has-error", !!r);
    },
    resources(r) {
      this.$emit("has-resources", r.length > 0);
    }
  },
  created() {
    this.fetchRelatedResources();
  },
  methods: {
    t: s,
    async fetchRelatedResources() {
      var r;
      if (!(!this.appEnabled || !this.hasResourceInfo)) {
        this.loading = !0, this.error = null, this.resources = [];
        try {
          const e = await o.get(this.url);
          this.resources = (r = e.data.ocs) == null ? void 0 : r.data;
        } catch (e) {
          this.error = e, console.error(e);
        } finally {
          this.loading = !1;
        }
      }
    }
  }
};
var h = function() {
  var e = this, t = e._self._c;
  return e.appEnabled && e.isVisible ? t("div", { staticClass: "related-resources" }, [t("div", { staticClass: "related-resources__header" }, [t("h5", [e._v(e._s(e.header))]), t("p", [e._v(e._s(e.subline))])]), e._l(e.resources, function(i) {
    return t("NcResource", { key: i.itemId, staticClass: "related-resources__entry", attrs: { icon: i.icon, name: i.title, url: i.url } });
  })], 2) : e._e();
}, m = [], y = /* @__PURE__ */ n(
  _,
  h,
  m,
  !1,
  null,
  "19300848",
  null,
  null
);
const S = y.exports;
export {
  S as default
};
